import { bankShop } from '../api/order'

export const BANK_SHOP_CACHE_KEY = 'bankShopOrderState'

export function getBankShopCache () {
  try {
    const cache = sessionStorage.getItem(BANK_SHOP_CACHE_KEY)
    return cache ? JSON.parse(cache) : null
  } catch (e) {
    return null
  }
}

export function setBankShopCache (data) {
  sessionStorage.setItem(BANK_SHOP_CACHE_KEY, JSON.stringify(data))
}

export function clearBankShopCache () {
  sessionStorage.removeItem(BANK_SHOP_CACHE_KEY)
  pendingRequest = null
}

let pendingRequest = null

export function getDefaultOrderTabName (state) {
  return state && state.hasBankShop ? 'myMainOrder' : 'myOrder'
}

export function swapMyOrderAndMainOrder (list) {
  const result = list.slice()
  const myOrderIndex = result.findIndex(item => item.name === 'myOrder' || (item.path && item.path.indexOf('type=myOrder') !== -1))
  const myMainOrderIndex = result.findIndex(item => item.name === 'myMainOrder' || (item.path && item.path.indexOf('type=myMainOrder') !== -1))
  if (myOrderIndex > -1 && myMainOrderIndex > -1) {
    const temp = result[myOrderIndex]
    result[myOrderIndex] = result[myMainOrderIndex]
    result[myMainOrderIndex] = temp
  }
  return result
}

export function initBankShopOrderState (shopCode) {
  if (!shopCode) {
    const emptyState = {
      shopCode: '',
      hasBankShop: false,
      bankShopInfo: null
    }
    setBankShopCache(emptyState)
    return Promise.resolve(emptyState)
  }

  const cache = getBankShopCache()
  if (cache && cache.shopCode === shopCode) {
    return Promise.resolve(cache)
  }

  if (pendingRequest && pendingRequest.shopCode === shopCode) {
    return pendingRequest.promise
  }

  const promise = bankShop({ shopCode }).then(res => {
    const hasBankShop = res.code === 200 && !!res.result
    const state = {
      shopCode,
      hasBankShop,
      bankShopInfo: hasBankShop ? res.result : null
    }
    setBankShopCache(state)
    return state
  }).catch(() => {
    const state = {
      shopCode,
      hasBankShop: false,
      bankShopInfo: null
    }
    setBankShopCache(state)
    return state
  }).finally(() => {
    pendingRequest = null
  })

  pendingRequest = { shopCode, promise }
  return promise
}



// WEBPACK FOOTER //
// ./src/utils/bankShopCache.js